import { textEditingUpdateTextMaker } from 'utils/actions';

export const MAIL_THREADS_FETCH = 'MAIL_THREADS_FETCH';
export const MAIL_THREADS_FETCH_SUCCESS = 'MAIL_THREADS_FETCH_SUCCESS';
export const MAIL_THREADS_FETCH_ERROR = 'MAIL_THREADS_FETCH_ERROR';
export const mailThreadsFetch = (page = 1) => ({type: MAIL_THREADS_FETCH, page});

export const MAIL_THREADS_UPDATE_POSSIBLE_PAGE = 'MAIL_THREADS_UPDATE_POSSIBLE_PAGE';
export const mailThreadsUpdatePossiblePage = possiblePage => ({type: MAIL_THREADS_UPDATE_POSSIBLE_PAGE, possiblePage});

export const MAIL_MESSAGE_THE_TEAM_EDITING_UPDATE_TEXT = 'MAIL_MESSAGE_THE_TEAM_EDITING_UPDATE_TEXT';
export const mailmailMessageTheTeamEditingUpdateText = textEditingUpdateTextMaker(MAIL_MESSAGE_THE_TEAM_EDITING_UPDATE_TEXT);

export const MAIL_MESSAGE_THE_TEAM_EDITING_RESET = 'MAIL_MESSAGE_THE_TEAM_EDITING_RESET';
export const mailmailMessageTheTeamEditingReset = () => ({type: MAIL_MESSAGE_THE_TEAM_EDITING_RESET});

export const MAIL_MESSAGE_THE_TEAM = 'MAIL_MESSAGE_THE_TEAM';
export const MAIL_MESSAGE_THE_TEAM_SUCCESS = 'MAIL_MESSAGE_THE_TEAM_SUCCESS';
export const MAIL_MESSAGE_THE_TEAM_ERROR = 'MAIL_MESSAGE_THE_TEAM_ERROR';
export const mailMessageTheTeam = text => ({type: MAIL_MESSAGE_THE_TEAM, text});

export const MAIL_THREAD_MESSAGE_UPDATE = 'MAIL_THREAD_MESSAGE_UPDATE';
export const MAIL_THREAD_MESSAGE_UPDATE_SUCCESS = 'MAIL_THREAD_MESSAGE_UPDATE_SUCCESS';
export const MAIL_THREAD_MESSAGE_UPDATE_ERROR = 'MAIL_THREAD_MESSAGE_UPDATE_ERROR';

export const mailThreadMessageUpdate = (threadId, threadMessageId, updates) => ({type: MAIL_THREAD_MESSAGE_UPDATE, threadId, threadMessageId, updates});

export const MAIL_THREAD_MESSAGES_FETCH = 'MAIL_THREAD_MESSAGES_FETCH';
export const MAIL_THREAD_MESSAGES_FETCH_SUCCESS = 'MAIL_THREAD_MESSAGES_FETCH_SUCCESS';
export const MAIL_THREAD_MESSAGES_FETCH_ERROR = 'MAIL_THREAD_MESSAGES_FETCH_ERROR';
export const mailThreadMessagesFetch = (threadId, page = 1) => ({type: MAIL_THREAD_MESSAGES_FETCH, threadId, page});

export const MAIL_THREAD_MESSAGES_UPDATE_POSSIBLE_PAGE = 'MAIL_THREAD_MESSAGES_UPDATE_POSSIBLE_PAGE';
export const mailThreadMessagesUpdatePossiblePage = (threadId, possiblePage) => ({type: MAIL_THREAD_MESSAGES_UPDATE_POSSIBLE_PAGE, possiblePage, threadId});

export const MAIL_THREAD_MESSAGE_CREATE = 'MAIL_THREAD_MESSAGE_CREATE';
export const MAIL_THREAD_MESSAGE_CREATE_SUCCESS = 'MAIL_THREAD_MESSAGE_CREATE_SUCCESS';
export const MAIL_THREAD_MESSAGE_CREATE_ERROR = 'MAIL_THREAD_MESSAGE_CREATE_ERROR';
export const mailThreadMessageCreate = (threadId, text) => ({type: MAIL_THREAD_MESSAGE_CREATE, threadId, text});

export const MAIL_THREAD_MESSAGE_EDITING_UPDATE_TEXT = 'MAIL_THREAD_MESSAGE_EDITING_UPDATE_TEXT';
export const mailThreadMessageEditingUpdateText = textEditingUpdateTextMaker(MAIL_THREAD_MESSAGE_EDITING_UPDATE_TEXT);

export const MAIL_THREAD_MESSAGE_EDITING_EXPAND = 'MAIL_THREAD_MESSAGE_EDITING_EXPAND';
export const mailThreadMessageEditingExpand = () => ({type: MAIL_THREAD_MESSAGE_EDITING_EXPAND});

export const MAIL_THREAD_MESSAGE_EDITING_RESET = 'MAIL_THREAD_MESSAGE_EDITING_RESET';
export const mailThreadMessageEditingReset = () => ({type: MAIL_THREAD_MESSAGE_EDITING_RESET});

export const MAIL_EMOJIS_SHOW = 'MAIL_EMOJIS_SHOW';
export const mailEmojisShow = key => ({type: MAIL_EMOJIS_SHOW, key});

export const MAIL_EMOJIS_HIDE = 'MAIL_EMOJIS_HIDE';
export const mailEmojisHide = key => ({type: MAIL_EMOJIS_HIDE, key});



/** WEBPACK FOOTER **
 ** ./src/members/state/mail/actions.js
 **/